import React, {useState, useEffect} from 'react'
import '../App.css'
import {
    Link,
} from "react-router-dom";

export const Downloads = (props) => {

    let [latestCloudDesktopVersion, setLatestCloudDesktopVersion] = useState({});
    let [latestServerVersion, setLatestServerVersion] = useState({});

    useEffect(() => {
        async function fetchLatestDesktopVersion() {
            
            const baseUrl = process.env.REACT_APP_API_URL;

            fetch(
                `${baseUrl}/restServices/commonConfigurationController/getLatestDesktopVersionInfo`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json"
                    }
                }
            )
            .then(res => res.json())
            .then(response => {
                console.log("desktop:", response);
                setLatestCloudDesktopVersion(response.data);
                fetchLatestServerVersion();
            })
            .catch(error => console.log(error));
        }



        async function fetchLatestServerVersion() {
            
            const baseUrl = process.env.REACT_APP_API_URL;

            fetch(
                `${baseUrl}/restServices/commonConfigurationController/getLatestServerVersionInfo`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json"
                    }
                }
            )
            .then(res => res.json())
            .then(response => {
                console.log("server:", response);
                setLatestServerVersion(response.data);
                
            })
            .catch(error => console.log(error));
        }
          
    
        fetchLatestDesktopVersion();
        
    }, [latestCloudDesktopVersion.version, latestServerVersion.version]); 

    const downloadCloudDesktop = () => {
        console.log("Download cloud desktop...");
        downloadFile("BronzeTagDesktop", latestCloudDesktopVersion.downloadLink);
    }

    const downloadOnPremiseDesktop = () => {
        console.log("Download on premise desktop...");
        downloadFile("BronzeTagDesktop", latestCloudDesktopVersion.downloadLink);
    }

    const downloadOnPremiseServer = () => {
        console.log("Download on premise server...");
        downloadFile("BronzeTagDesktop", latestServerVersion.downloadLink);
    }

    const downloadFile = (fileName, location) => {
        const link = document.createElement('a')

        link.setAttribute('href', location);
        link.setAttribute('download', fileName);
        link.setAttribute('target', '_blank');
        link.style.display = 'none';

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
    }

    return (
        <div>
            <div className="container">

                <h3 className="mt-4 mb-3">BronzeTag POS Software Downloads

                </h3>

                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                        {/* <a href="index.html">Home</a> */}
                    </li>
                    <li className="breadcrumb-item">
                        <Link to="/pos">Point of sale</Link>
                        {/* <a href="index.html">Home</a> */}
                    </li>
                    <li className="breadcrumb-item active">Downloads</li>
                </ol>



            </div>

            <div className="container" style={{marginBottom: 300}}>


                <div className="row" style={{ marginTop: 18 }}>
                    <div className="col-lg-6 mb-6">
                        <h2>Cloud Based</h2>
                        {latestCloudDesktopVersion.version && <button onClick={() => downloadCloudDesktop()}><i className="fa fa-download"></i>{`Download Desktop v${latestCloudDesktopVersion.version}`}</button>}
                        <p style={{textAlign: 'left', marginTop: 12}}>With the cloud based solution, your data is hosted securely on the cloud. All of your store and online transactions are stored in one location.  </p>
                        <p style={{textAlign: 'left', marginBottom: 12}}>Our servers are available 24/7 and all you need to maintain is the Cash Register. All you need is a computer with an internet connection. Just download the Desktop software and install it on your Windows 10 PC/Laptop and you literally have your POS System up and running.  </p>

                        <a href="https://bronzetag-desktop-downloads.s3.amazonaws.com/tripos-desktop-setup-20240506.exe">Download latest desktop software</a>
                    </div>
                    <div className="col-lg-6 mb-6">
                        <h2>On Premise</h2>
                        {latestCloudDesktopVersion.version && <button onClick={() => downloadOnPremiseDesktop()}><i className="fa fa-download"></i>{`Download Desktop v${latestCloudDesktopVersion.version}`}</button>}
                        {latestServerVersion.version && <button onClick={() => downloadOnPremiseServer()} style={{marginTop: 12}}><i className="fa fa-download"></i>{`Download Server v${latestServerVersion.version}`}</button>}
                        <p style={{textAlign: 'left', marginTop: 12}}>Our on premise solution gives you the flexibility to host your data on your own servers. Cash registers communicate with your server over your local area network (wired/wireless).  </p>
                        
                    </div>
                    
                </div>

            </div>
        </div>
    )
}